import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Send, Loader2, Mail, Check } from "lucide-react";

const INPUT = "bg-white/5 border-white/10 text-white placeholder:text-gray-600 text-sm";

export const OutreachEmailForm = ({ email, lead, sending, sent, onSend }) => (
  <div className="space-y-3">
    <h3 className="text-sm font-medium text-gray-300 uppercase tracking-wider flex items-center gap-2"><Mail className="h-4 w-4 text-ism-teal" /> Email</h3>
    <div>
      <label className="text-xs text-gray-500 mb-1 flex items-center justify-between">
        <span>To</span>
        {lead?.emailConfidence && <span className="text-xs text-gray-500">{lead.emailConfidence}% confidence</span>}
      </label>
      <Input value={email.recipientEmail} onChange={(e) => email.setRecipientEmail(e.target.value)} placeholder="recipient@company.com" className={INPUT} data-testid="outreach-recipient-email" />
    </div>
    <div>
      <label className="text-xs text-gray-500 mb-1 block">Subject</label>
      <Input value={email.subject} onChange={(e) => email.setSubject(e.target.value)} placeholder="Email subject" className={INPUT} data-testid="outreach-subject" />
    </div>
    <div>
      <label className="text-xs text-gray-500 mb-1 block">Body</label>
      <Textarea value={email.body} onChange={(e) => email.setBody(e.target.value)} rows={8} className={`${INPUT} resize-none`} data-testid="outreach-body" />
    </div>
    {sent ? (
      <div className="flex items-center gap-2 p-3 rounded-lg bg-green-500/10 border border-green-500/30" data-testid="outreach-sent">
        <Check className="h-5 w-5 text-green-400" /><span className="text-sm text-green-400">Email sent to {email.recipientEmail}</span>
      </div>
    ) : (
      <Button onClick={onSend} disabled={sending || !email.recipientEmail.trim()} className="w-full bg-ism-teal hover:bg-ism-teal/90 text-black font-medium" data-testid="send-email-btn">
        {sending ? <><Loader2 className="h-4 w-4 animate-spin mr-2" /> Sending...</> : <><Send className="h-4 w-4 mr-2" /> Send Email</>}
      </Button>
    )}
  </div>
);
